import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {getColorObjectArrayFromFillColor, getRGBAArrayFromColorStorage} from '@Utils/color.util';
import type {ColorStorage} from '@Components/color-picker-v2';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromMenuItem} from '@Hooks/poster-editor/useGetKeyFromMenuItem';

export function MenuIconColorPanel(): ReactElement {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const iconsColor = useGetKeyFromMenuItem('iconsColor');

  if (!activeItem || (activeItem && !('iconsColor' in activeItem)) || !iconsColor) {
    throw new Error('Item does not have iconsColor property');
  }

  if (!activeItem.isMenu()) {
    throw new Error(`Expected menu item but got ${activeItem.gitype} instead`);
  }

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    activeItem.updateIconsColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };

  const onChangeEnded = (updatedColor: ColorStorage[]): void => {
    activeItem.updateIconsColor(getRGBAArrayFromColorStorage(updatedColor)[0], true);
  };

  return (
    <PosterEditingBaseColorPanel
      id="menu-icon-color-panel"
      isGradientEnabled={false}
      color={getColorObjectArrayFromFillColor([activeItem.iconsColor])}
      onChangeColor={onChangeColor}
      onChangeEnded={onChangeEnded}
      isAlphaDisabled
    />
  );
}
